import React, { useState, useEffect, useCallback } from 'react';

import { FixedSizeList as List } from 'react-window';

import {
  Card,
  CardContent as CardBody,
  CardTitle,
  CardHeader,
  CardFooter,
} from '@shadcn/components/ui/card';

import MultiSelect from '@shadcn/components/ui/react-select';

import useShopifyLocationsStore from '@zustand/useShopifyLocationsStore';

import {
  SelectContent,
  SelectValue,
  SelectItem,
  Select,
  SelectTrigger,
} from '@shadcn/components/ui/select';
import useQuery from '../../../helpers/JIFI/useQuery';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { Country, State } from 'country-state-city';
import EditAddressModal from '../../../components/shared/EditAddressModal';

import superagent from 'superagent';
import { backendUrl } from '../../../helpers/consts.js';
import { useHistory } from 'react-router-dom';

import { toast, ToastContainer } from 'react-toastify';
import { Row } from '@shadcn/components/ui/row';
import { Col } from '@shadcn/components/ui/col';
import { Button } from '@shadcn/components/ui/button';
import { Input as InputShadcn } from '@shadcn/components/ui/input';

import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
  DialogHeader,
} from '@shadcn/components/ui/dialog';

import LocationHierarchyCreateModal from '../location-hierarchy/CreateHierarchyModal';


import { Collapsible, CollapsibleContent } from '@shadcn/components/ui/collapsible';

export const logisticOptions = [
  { value: 'EWE', label: 'EWE Melbourne' },
  { value: 'EWESYD', label: 'EWE Sydney' },
  { value: 'EWEBRS', label: 'EWE Brisbane' },
  { value: 'EWEPTH', label: 'EWE Perth' },
  { value: 'EWEADE', label: 'EWE Adelaide' },
  { value: 'EWENZ', label: 'EWE New Zealand' },
  { value: 'UNIS', label: 'Unis' },
  { value: 'Airbox', label: 'Airbox' },
  { value: 'LaunchUtah', label: 'Launch Utah' },
  { value: 'LaunchKentucky', label: 'Launch Kentucky' },
];

const emptyAddress = {
  address1: '',
  address2: '',
  phone: '',
  city: '',
  zip: '',
  country: 'Australia',
  company: '',
  province: 'Victoria',
};

const Accordian = ({ children, title }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div id="accordion">
        <Card className="mb-1  bg-[#f6f6f6]">
          <CardHeader
            onClick={() => setOpen((prev) => !prev)}
            className="p-3"
            id="headingOne"
          >
            <h6 className="m-0 text-[14px] font-medium">
              <span style={{ cursor: 'pointer' }} className={''}>
                {title}
              </span>
            </h6>
          </CardHeader>
          <Collapsible open={open} onValueChange={() => setOpen((prev) => !prev)}>
            <CollapsibleContent>
              <Card className='rounded-none'>
                <CardBody>{children}</CardBody>
              </Card>
            </CollapsibleContent>
          </Collapsible>
        </Card>
      </div>
      <br />
      <br />
    </>
  );
};


const RowItem = React.memo(
  ({
    index,
    data,
    style,


  }) => {
    const { products, editProductRow, editVariantRow, editQuantityRow, removeRow } = data
    const line = data.stock[index];
    const product = products.find((val) => val._id === line.product);
    const variant =
      product && product.variants.find((val) => val._id === line.variant);

    const [fulfillmentModalOpen, setFulfillmentModalOpen] = useState(false);
    return (
      <Row style={{ padding: '12px 0', gap: '10px', ...style }} key={index}>
        <Col className="sm:w-4/12">
          <div className='border border-black rounded px-3 py-2'>
            <select
              disabled={true}
              value={line.product}
              onChange={(e) => editProductRow(index, e.target.value)}
              style={{ width: '100%', height: '100%' }}
            >
              <option value="" disabled>Select Product</option>
              {products.map((val) => (
                <option key={val._id} value={val._id}>
                  {val.name}
                </option>
              ))}
            </select>
          </div>
        </Col>
        <Col className="sm:w-4/12">
          <div className='border border-black rounded px-3 py-2'>
            <select
              disabled={true}
              value={line.variant}
              onChange={(e) => editVariantRow(index, e.target.value)}
              style={{ width: '100%', height: '100%' }}
            >
              <option value="" disabled>Select Variant</option>
              {product?.variants.map((val) => (
                <option
                  key={val._id}
                  value={val._id}
                  disabled={val.selected !== -1 && val.selected !== index}
                >
                  {val.name}
                </option>
              ))}
            </select>
          </div>
        </Col>
        <Col className="sm:w-3/12">
          <input
            disabled={true}
            key={index}
            style={{ width: '90%', height: '100%' }}
            type="number"
            className='border border-black rounded px-3 py-2'
            value={line.quantity}
            onChange={(e) => {

              editQuantityRow(index, e.target.value)
            }}
          />
        </Col>

      </Row>
    );
  }
);

export const StockInput = ({ stock, setStock, productData }) => {

  const listRef = React.useRef(null);
  const handleAddRow = useCallback(() => {
    const prefillProduct = stock[stock.length - 1]?.product;
    let prefillVariant;
    if (prefillProduct) {
      prefillVariant = productData.find((val) => prefillProduct === val._id)[
        'variants'
      ][0]._id;


    }

    const item = {
      product: prefillProduct || productData?.[0]._id,
      variant: prefillVariant || productData?.[0]['variants']?.[0]._id,
      quantity: 0,
    };

    setStock((prev) => [...prev ?? {}, item]);
    scrollToBottom()
  }, [stock, productData, setStock]);


  const scrollToBottom = () => {
    if (listRef.current) {
      setTimeout(() => listRef.current.scrollToItem(stock.length), 500);
    }
  };


  const editProductRow = useCallback(
    (id, productId) => {
      setStock((prev) => {
        let newList = [...prev];
        newList[id]['product'] = productId;
        newList[id]['quantity'] = 0;
        const variant = productData.find(
          (val) => `${val._id}` === `${productId}`
        );
        newList[id]['variant'] = variant.variants[0]?._id;
        return newList;
      });
    },
    [productData, setStock]
  );

  const editVariantRow = useCallback(
    (id, val) => {
      setStock((prev) => {
        let newList = [...prev];
        newList[id]['variant'] = val;
        newList[id]['quantity'] = 0;
        return newList;
      });
    },
    [setStock]
  );

  const editQuantityRow =
    (id, val) => {
      console.log("test id", id, val)
      setStock((prev) => {
        let newList = [...prev];
        let parsedInput = parseInt(val);
        if (parsedInput < 0) {
          parsedInput = 0;
        }
        newList[id]['quantity'] = parsedInput;
        return newList;
      });
    }


  const removeRow = useCallback(
    (id) => {
      setStock((prev) => {
        let newList = prev?.filter((item, key) => key !== id);
        return newList;
      });
    },
    [setStock]
  );


  const products = productData && Object.keys(stock).length > 0
    ? productData.map((product) => {
      const variants = product.variants.map((variant) => {
        return {
          _id: variant._id,
          name: variant.name,
          selected: stock?.findIndex((val) => val.variant === variant._id),
        };
      });

      return {
        name: product.name,
        _id: product._id,
        variants,
      };
    })
    : [];

  return (
    <>
      <Row className='mt-4'>
        <Col xs="4">Product</Col>
        <Col xs="4">Variant</Col>
        <Col xs="4">Quantity</Col>
      </Row>
      <br />
      <List
        height={
          stock.length === 0 ? 60 : stock.length < 10 ? 60 * stock.length : 600
        }
        ref={listRef}
        itemData={{ stock, products, editProductRow, editVariantRow, editQuantityRow, removeRow }}
        itemCount={stock.length}
        itemSize={60}
        itemKey={(index) => index}
        width="100%"
      >
        {RowItem}
      </List>
      {/* <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          marginTop: 12,
        }}
      >
        <Button onClick={handleAddRow} variant="primary">
          Add
        </Button>
      </div> */}
    </>
  );
};

const LocationListPage = ({ match: { params } }) => {
  const history = useHistory();
  const { locationID } = params;

  const [isHierarchyModalOpen, setHierarchyModalOpen] = useState(false);

  const handleCreateHierarchy = useCallback(() => {
    if (!locationID) {
      return;
    }

    setHierarchyModalOpen(true);
  }, [locationID]);

  const handleOpenAssignSku = useCallback(() => {
    if (!locationID) {
      return;
    }

    history.push(`/location/edit/${locationID}/hierarchy/assign`);
  }, [history, locationID]);

  const [locationName, setLocationName] = useState('');
  const [code, setCode] = useState('');
  const [locationAustralian, setLocationAustralian] = useState(false);

  const [factoryOptions, setFactoryOptions] = useState([]);
  const [locationFactory, setLocationFactory] = useState();

  const [region, setRegion] = useState('');
  const [locationLogisticsProvider, setLocationLogisticsProvider] =
    useState('');
  const [shopifyLinks, setShopifyLinks] = useState([]);
  const [amazonLinks, setAmazonLinks] = useState([]);
  const [amazonModalOpen, setAmazonModalOpen] = useState(false);
  const [allAmazonConfigs, setAllAmazonConfigs] = useState([]);
  const [tempAmazonSelections, setTempAmazonSelections] = useState([]);
  const [isRetailStore, setIsRetailStore] = useState(false);
  const [addressEditModal, setAddressEditModal] = useState();
  const toggleAddressEditModal = () => {
    setAddressEditModal((prev) => !prev);
  };
  const [address, setAddress] = useState(emptyAddress);
  const [topupSchedule, setTopupSchedule] = useState(null);

  const [refresh, setRefresh] = useState(false);

  const [fulfillmentModalOpen, setFulfillmentModalOpen] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const [regionOptions, regionOptionsState] = useQuery({
    url: `/inventory/getRegions`,
  });
  const refreshData = useCallback(() => setRefresh((prev) => !prev), []);

  const [stockPull, setStockPull] = useState([]);
  const [data, productState] = useQuery({
    url: `/product`,
    refresh,
  });
  const productData = data && data.data;

  const [location, state] = useQuery({
    refresh,
    url: `/inventory/location/${locationID}`,
  });

  const [selectedTopupLocation, setSelectedTopupLocation] = useState({})
  const [selectedReplenLocations, setSelectedReplenLocations] = useState([]);
  const [replenLocations, replenLocationStates] = useQuery({
    refresh,
    url: `/inventory/getReplenishLocations`,
  });

  useEffect(() => {
    if (
      replenLocations !== undefined &&
      replenLocationStates !== 'loading' &&
      selectedReplenLocations?.filter((val) => val.label == undefined).length > 0
    ) {
      setSelectedReplenLocations((prev) => {
        return prev.map((replenLocation) => {
          return {
            value: replenLocation.value,
            label: replenLocations?.find(
              (val) => val._id === replenLocation.value
            ).name,
          };
        });
      });
    }
  }, [replenLocations, selectedReplenLocations]);

  console.log('topupSchedule', topupSchedule);
  useEffect(() => {
    if (location != undefined) {
      setLocationName(location.display_name);
      setCode(location.code);
      setLocationAustralian(location.australian);
      setLocationLogisticsProvider(location.logistics_provider);
      setShopifyLinks(location.shopify_links || []);
      setAmazonLinks(location.amazonSellerConfigs || []);
      setAddress(location.address || emptyAddress);
      setSelectedReplenLocations(
        (location.stockDropLocations || []).map((val) => ({ value: val })) ?? []
      );
      setIsRetailStore(location.isRetailStore);
      setRegion(location?.region);
      if (location.topupSchedule) {
        setTopupSchedule(location.topupSchedule);
      } else {
        setTopupSchedule(null);
      }

      if (
        factoryOptions.length > 0 &&
        location.factory !== '' &&
        location.factory !== undefined
      ) {
        let fac = factoryOptions.find(
          (val) => `${val._id}` === `${location.factory}`
        );
        if (fac !== undefined) {
          setLocationFactory({
            value: location.factory,
            label: fac.name,
          });
        }
      } else {
        setLocationFactory({ value: location.factory });
      }

      let items = [];
      for (let variantCount of location.topupLevel) {
        const item = {
          product: variantCount.variant.product,
          variant: variantCount.variant._id,
          quantity: variantCount.count.on_hand,
        };
        items.push(item);
      }
      setStockPull((prev) => items);
    }
  }, [location]);

  const updateLocation = (e) => {
    e.preventDefault();
    setSaveLoading(true);

    if (location == undefined) {
      superagent
        .post(`${backendUrl}/inventory/createLocation`)
        .send({
          name: locationName,
          code: code,
          australian: locationAustralian,

          logistics_provider: locationLogisticsProvider,
          isRetailStore,
          region,
          amazonSellerConfigs: amazonLinks,
          ...(locationFactory?.value != null
            ? { factory: locationFactory.value }
            : {}),
          ...(topupSchedule ? { topupSchedule: topupSchedule } : {})
        })
        .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
        .set('accept', 'json')
        .on('error', (response) => {
          const code = response.status;
          const errorMessage = response?.response?.body?.message || response?.body?.message || `Failed to create location (Error ${code})`;
          toast.error(errorMessage);
          setSaveLoading(false);
        })
        .then((response) => {
          const code = response.status;
          if (code > 400) {
            toast.error(`Failed to create location (Error ${code})`);
          } else {
            toast.success('Location created successfully');
            history.push(`/location/edit/${response.body._id}`);
          }
        })
        .catch((err) => {
          console.log(err);
          setSaveLoading(false);
        });
    } else {

      superagent
        .put(`${backendUrl}/inventory/location/${locationID}`)
        .send({
          name: locationName,
          code: code,
          australian: locationAustralian,

          logistics_provider: locationLogisticsProvider,
          shopify_links: shopifyLinks.map(({ locationVariantIds, ...rest }) => ({
            ...rest,
          })),
          amazonSellerConfigs: amazonLinks,
          address: address,
          isRetailStore,
          region,
          ...(topupSchedule ? { topupSchedule: topupSchedule } : {}),
          stockDropLocations: selectedReplenLocations?.map((val) => val.value) ?? [],
          ...(locationFactory?.value != null
            ? { factory: locationFactory.value }
            : {}),

        })
        .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
        .set('accept', 'json')
        .on('error', (response) => {
          const code = response.status;
          const errorMessage = response?.response?.body?.message || response?.body?.message || `Failed to update location (Error ${code})`;
          toast.error(errorMessage);
          setSaveLoading(false);
        })
        .then((response) => {
          const code = response.status;
          if (code > 400) {
            const errorMessage = response?.response?.body?.message || response?.body?.message || `Failed to update location (Error ${code})`;
            toast.error(errorMessage);
            setSaveLoading(false);

          } else {
            toast.success('Location updated successfully');

            setRefresh(prev => !prev);
          }
          setSaveLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setSaveLoading(false);
        });
    }
  };

  useEffect(() => {
    superagent
      .post(`${backendUrl}/product/productFactories`)
      .send()
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
      .set('accept', 'json')
      .on('error', (response) => {
        const code = response.status;
        history.replace(history.location.pathname, {
          errorStatusCode: code,
        });
      })
      .then((response) => {
        const code = response.status;
        if (code > 400) {
          history.replace(history.location.pathname, {
            errorStatusCode: code,
          });
        } else {
          setFactoryOptions(response.body);
          setLocationFactory((prev) => {
            console.log(prev);
            if (prev && prev !== '' && prev.value !== undefined) {
              return {
                value: prev.value,
                label: response.body.find((val) => `${val._id}` === prev.value)
                  ?.name,
              };
            }
            return prev;
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  let [shopifySyncModalOpen, setShopifySyncModalOpen] = useState(false);

  const isShopifyLinked = shopifyLinks?.length > 0;
  const isAmazonLinked = amazonLinks?.length > 0;
  const shouldShowShopifyButton = !isAmazonLinked || isShopifyLinked;
  const shouldShowAmazonButton = !isShopifyLinked || isAmazonLinked;

  return (
    <>
      {locationID ? (
        <LocationHierarchyCreateModal
          open={isHierarchyModalOpen}
          onOpenChange={setHierarchyModalOpen}
          locationCode={location?.code}
          locationName={location?.display_name}
          onCreated={refreshData}
        />
      ) : null}
      <div className="page-content">
        <div className="w-full px-3 mx-auto xl:max-w-[85%]">
          <Breadcrumbs
            title="Ecommerce"
            breadcrumbItem={
              locationID != undefined ? 'Edit Location' : 'New Location'
            }
            addOn={
              locationID ? (
                <div className="flex gap-2">
                  <Button size="default" onClick={handleCreateHierarchy}>
                    Create Node
                  </Button>
                  <Button
                    size="default"
                    variant="outline"
                    onClick={handleOpenAssignSku}
                  >
                    Assign SKU
                  </Button>
                </div>
              ) : null
            }
          />

          <Row>
            <Col className="w-full">
              <Card className="pt-6 mb-6">
                <CardBody>
                  <Row className='flex flex-row gap-6 items-center'>
                    <CardTitle className='text-[15px]'>Location Information</CardTitle>

                  </Row>
                  <br />
                  <div>
                    <Row className="flex-wrap">
                      <Col className="sm:w-6/12 pr-3">
                        <div className="mb-4">
                          <label htmlFor="locationname">Location Name</label>
                          <InputShadcn
                            id="locationname"
                            name="locationname"
                            type="text"
                            className="form-control"
                            value={locationName}
                            onChange={(e) => setLocationName(e.target.value)}
                          />
                        </div>
                        <div className="mb-4">
                          <label htmlFor="locationname">Code</label>
                          <InputShadcn
                            id="locationname"
                            name="locationname"
                            type="text"
                            className="form-control"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                          />
                        </div>
                        <div className="mb-4">
                          <label htmlFor="locationname">
                            Logistics Provider
                          </label>
                          <Select
                            value={locationLogisticsProvider}
                            onValueChange={(value) =>
                              setLocationLogisticsProvider(value)
                            }
                          >
                            <SelectTrigger
                              style={{ width: '100%', height: '100%' }}
                            >
                              <SelectValue placeholder="None" />
                            </SelectTrigger>

                            <SelectContent className="z-[1500]">
                              {logisticOptions.map((option) => (
                                <SelectItem
                                  key={option.value}
                                  value={option.value}
                                >
                                  {option.label}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>

                        <div className="mb-4">
                          <label htmlFor="regionSelect">Select Region</label>
                          <Select
                            value={region}
                            onValueChange={(value) => setRegion(value)}
                            name="select"
                            id="regionSelect"
                          >
                            <SelectTrigger
                              style={{ width: '100%', height: '100%' }}
                            >
                              <SelectValue placeholder="Please select region" />
                            </SelectTrigger>

                            <SelectContent className="z-[1500]">
                              {regionOptions?.map((regionOption) => (
                                <SelectItem
                                  key={regionOption.id}
                                  value={regionOption.id}
                                  selected={regionOption.id === region}
                                >
                                  {regionOption.label}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>

                        <div className="mb-4" check>
                          <label check>
                            <input
                              type="checkbox"
                              checked={isRetailStore}
                              onChange={() => setIsRetailStore(!isRetailStore)}
                            />{' '}
                            Retail Store
                          </label>
                        </div>
                        <div
                          style={{
                            margin: '16px 0',
                            background: '#eee',
                            borderRadius: 17,
                            padding: 16,
                          }}
                        >
                          <h6 className='font-medium' style={{ marginBottom: 16 }}>
                            {' '}
                            Shipping Address -{' '}
                            <a href="#" onClick={toggleAddressEditModal} className='text-[#1f3dd0]'>
                              edit
                            </a>
                          </h6>
                          <div> {address?.name} </div>
                          <div> {address?.address1} </div>
                          <div> {address?.address2 || ''} </div>
                          <div>
                            {' '}
                            {`${address?.city || ''} ${address?.province || ''
                              } ${address?.zip || ''}`}{' '}
                          </div>
                          <div> {address?.country || ''} </div>
                          <div> {address?.phone || ''} </div>
                        </div>
                        {locationLogisticsProvider !== '' && (
                          <div className="mb-4">
                            <label htmlFor="locationname">
                              Replenishment Locations
                            </label>
                            <MultiSelect
                              isMulti
                              options={replenLocations?.map((val) => ({
                                value: val._id,
                                label: val.name,
                              }))}
                              value={selectedReplenLocations}
                              onChange={setSelectedReplenLocations}
                            />
                          </div>
                        )}
                      </Col>
                      {location !== undefined && (
                        <Col className="sm:w-6/12 pl-3">
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'stretch',
                              flexDirection: 'column',
                            }}
                          >
                            {shopifyLinks?.map((val) => {
                              return (
                                <div
                                  key={val.location_id}
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    border: '1px solid #ccc',
                                    borderRadius: 26,
                                    marginBottom: 16,
                                    padding: 16,
                                  }}
                                >
                                  <div>
                                    <b>{val.name}</b>
                                  </div>
                                  <div>
                                    <i className="bx bxl-shopify" /> {val.store}
                                    .myshopify.com
                                  </div>
                                  <div>Sync type: {val.sync_type}</div>
                                </div>
                              );
                            })}

                            {amazonLinks?.map((configId) => {
                              const config = allAmazonConfigs.find(c => c._id === configId);
                              return (
                                <div
                                  key={configId}
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    border: '1px solid #ccc',
                                    borderRadius: 26,
                                    marginBottom: 16,
                                    padding: 16,
                                  }}
                                >
                                  <div>
                                    <b>{config?.storeKey || 'Amazon Config'}</b>
                                  </div>
                                  <div>
                                    <i className="bx bxl-amazon" /> {config?.region || 'Amazon Seller Configuration'}
                                  </div>
                                  <div>Marketplaces: {config?.marketplaces?.map(m => m.name).join(', ') || 'N/A'}</div>
                                </div>
                              );
                            })}

                            {/* Conditional button display based on existing links */}
                            {shouldShowShopifyButton && (
                              <div
                                style={{
                                  alignItems: 'center',
                                  borderStyle: 'dashed',
                                  borderWidth: '2px',
                                  borderRadius: '20px',
                                  borderColor: 'rgb(204, 204, 204)',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  height: '100%',
                                  justifyContent: 'center',
                                  padding: '20px',
                                  cursor: 'pointer',
                                }}
                                onClick={() => setShopifySyncModalOpen(true)}
                              >
                                <i className="bx bxl-shopify" />{' '}
                                {'Link to Shopify'}
                              </div>
                            )}

                            {shouldShowAmazonButton && (
                              <div
                                style={{
                                  alignItems: 'center',
                                  borderStyle: 'dashed',
                                  borderWidth: '2px',
                                  borderRadius: '20px',
                                  borderColor: 'rgb(204, 204, 204)',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  height: '100%',
                                  justifyContent: 'center',
                                  padding: '20px',
                                  cursor: 'pointer',
                                }}
                                className={shouldShowShopifyButton ? 'mt-4' : ''}
                                onClick={() => setAmazonModalOpen(true)}
                              >
                                <i className="bx bxl-amazon" />{' '}
                                {'Link to Amazon'}
                              </div>
                            )}
                          </div>
                        </Col>
                      )}
                      <Col className="w-full">

                        <Accordian title="Top up amount">
                          <StockInput
                            stock={stockPull}
                            setStock={setStockPull}
                            productData={productData}
                          />
                        </Accordian>
                      </Col>
                    </Row>
                    <Button
                      onClick={updateLocation}
                      type="submit"
                      variant="success"
                      className="mr-1 waves-effect waves-light"
                      disabled={saveLoading}
                    >
                      {saveLoading ? (
                        <>
                          <i className="bx bx-loader-alt bx-spin me-2"></i>
                          Saving...
                        </>
                      ) : (
                        'Save Changes'
                      )}
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <ShopifySyncModal
        modal={shopifySyncModalOpen}
        togglemodal={() => setShopifySyncModalOpen((prev) => !prev)}
        location={location}
        history={history}
        shopifyLinks={shopifyLinks}
        setShopifyLinks={setShopifyLinks}
        address={address}
      />
      <AmazonSyncModal
        modal={amazonModalOpen}
        togglemodal={() => setAmazonModalOpen((prev) => !prev)}
        amazonLinks={amazonLinks}
        setAmazonLinks={setAmazonLinks}
        setAllAmazonConfigs={setAllAmazonConfigs}
        tempAmazonSelections={tempAmazonSelections}
        setTempAmazonSelections={setTempAmazonSelections}
      />
      <EditAddressModal
        modal={addressEditModal}
        togglemodal={toggleAddressEditModal}
        address={address}
        setAddress={setAddress}
      />

      <ToastContainer />
    </>
  );
};

const ShopifySyncModal = ({
  modal,
  togglemodal,
  history,
  location,
  shopifyLinks,
  setShopifyLinks,
  address,
}) => {

  const [stage, setStage] = useState(0);
  const { locations, setLocations } = useShopifyLocationsStore()
  const [loading, setLoading] = useState(false);
  const [shopifyLocations, setShopifyLocation] = useState({});
  const [selectedLocation, setSelectedLocation] = useState();

  const [syncSettings, setSyncSetttings] = useState({
    type: 'NONE',
  });

  const stateCode = State.getStatesOfCountry(
    Country.getAllCountries().find((val) => val.name === address.country)
      ?.isoCode
  )?.find((val) => val.name === address.province)?.isoCode;

  const countryCode = Country.getAllCountries().find(
    (val) => val.name === address.country
  )?.isoCode;

  const currentLinkObject = {
    location_id: selectedLocation?.id,
    name: location?.name,
    store: selectedLocation?.locale,
    sync_type: syncSettings.type,
  };

  console.log(currentLinkObject);

  useEffect(() => {
    fetchShopifyLocations();
  }, [location]);

  const handleSave = () => {
    setShopifyLinks((prev) => [...prev, currentLinkObject]);
    togglemodal();
  };

  const fetchShopifyLocations = () => {
    superagent
      .post(`${backendUrl}/inventory/fetchShopifyLocations`)
      .send()
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
      .set('accept', 'json')
      .on('error', (response) => {
        const code = response.status;
        history.replace(history.location.pathname, {
          errorStatusCode: code,
        });
      })
      .then((response) => {
        const code = response.status;
        if (code > 400) {
          history.replace(history.location.pathname, {
            errorStatusCode: code,
          });
        } else {
          setLocations(response.body)
          setShopifyLocation(response.body);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCreateLocation = async (locale) => {
    setLoading(true);

    if (
      !location?.name ||
      !address.address1 ||
      !address.city ||
      !address.province ||
      !address.country ||
      !address.zip
    ) {
      toast.info('Please fill in all fields in address.');
      setLoading(false);
      return;
    }

    const apiEndpoint = `${backendUrl}/inventory/addShopifyLocations`;
    const apiPayload = {
      store: locale,
      name: location?.name,
      address1: address.address1,
      address2: address.address2,
      phone: address.phone,
      city: address.city,
      provinceCode: stateCode,
      countryCode: countryCode,
      zip: address.zip,
    };

    try {
      const response = await superagent
        .post(apiEndpoint)
        .send(apiPayload)
        .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
        .set('accept', 'json');
      const error =
        response?.body?.data?.locationAdd?.userErrors[0]?.message ||
        response?.body?.errors?.[0]?.message;
      if (error) {
        toast.error(error);
        return;
      }
      toast.success('Location created successfully');
      fetchShopifyLocations();
    } catch (error) {
      console.error('Error adding location:', error);
    } finally {
      setLoading(false);
    }
  };

  const stageComponents = [
    <DialogContent hideClose className="z-[1500] max-h-[80vh] overflow-y-auto pt-0 min-w-[60vw]">
      <CardBody className="p-0 px-0">
        <h4 className="card-title mb-4 pt-6">Select Shopify Location</h4>

        <br />
        {Object.keys(shopifyLocations).map((locale) => {
          return (
            <div>
              <div className="flex flex-row items-center justify-start">
                <h3 className="me-2">{locale}.myshopify.com:</h3>
                <Button
                  variant="success"
                  onClick={() => handleCreateLocation(locale)}
                  className="ml-2 mb-2"
                >
                  Create
                </Button>
              </div>

              <br />
              <Row className="flex-wrap gap-4">
                {shopifyLocations[locale].locations
                  ?.filter(
                    (val) =>
                      !shopifyLinks
                        .map((val) => val.location_id)
                        .includes(val.id)
                  )
                  .map((location, index) => (
                    <Col key={index} className="w-[23%]">
                      <Card className="flex flex-col h-full">
                        <CardHeader>
                          <h4>{location.name}</h4>
                        </CardHeader>
                        <CardBody className="flex-grow min-h-[150px]">
                          <div>{location.address1}</div>
                          <div>{location.city}</div>
                          <div>{location.province}</div>
                          <div>{location.country}</div>
                        </CardBody>
                        <CardFooter>
                          <Button
                            onClick={() => {
                              setSelectedLocation({
                                locale: locale,
                                id: location.id,
                              });
                            }}
                            variant={
                              selectedLocation?.id === location.id
                                ? 'success'
                                : 'primary'
                            }
                            className="mr-1 waves-effect waves-light"
                          >
                            {selectedLocation?.id === location.id
                              ? 'Selected'
                              : 'Select'}
                          </Button>
                        </CardFooter>
                      </Card>
                    </Col>
                  ))}
              </Row>
              <br />
            </div>
          );
        })}
      </CardBody>
      <DialogFooter>
        {loading ? (
          <div className="spinner-border text-primary m-1" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        ) : (
          <Button
            onClick={() =>
              selectedLocation !== undefined ? setStage(1) : () => { }
            }

            variant={selectedLocation !== undefined ? 'success' : 'secondary'}
            className="btn-lg btn-rounded"
          >
            Next
          </Button>
        )}
      </DialogFooter>
    </DialogContent>,
    <DialogContent>
      <CardBody className='p-0'>
        <h4 className="card-title mb-4 p-0">Select Shopify Location</h4>
        <br />
        <div className="mb-4">
          <label htmlFor="locationname">Stock Sync Type</label>
          <Select
            value={syncSettings.type}
            onValueChange={(value) =>
              setSyncSetttings({ ...syncSettings, type: value })
            }
          >
            <SelectTrigger style={{ width: '100%', height: '100%' }}>
              <SelectValue />
            </SelectTrigger>

            <SelectContent className="z-[1500]">
              {['NONE', 'PUSH', 'PULL'].map((val) => (
                <SelectItem key={val} value={val}>
                  {val}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </CardBody>
      <DialogFooter>
        {loading ? (
          <div className="spinner-border text-primary m-1" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        ) : (
          <>
            <Button
              onClick={() => setStage(0)}
              color={'warning'}
              className="btn-lg btn-rounded"
            >
              Back
            </Button>
            <Button
              onClick={handleSave}
              variant={selectedLocation !== undefined ? 'success' : 'secondary'}
              className="btn-lg btn-rounded"
            >
              Save
            </Button>
          </>
        )}
      </DialogFooter>
    </DialogContent>,
  ];

  return (
    <Dialog
      open={modal}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabindex="-1"
      size="lg"
      onOpenChange={togglemodal}
    >
      {stageComponents[stage]}
    </Dialog>
  );
};

const AmazonSyncModal = ({
  modal,
  togglemodal,
  amazonLinks,
  setAmazonLinks,
  setAllAmazonConfigs,
  tempAmazonSelections,
  setTempAmazonSelections,
}) => {
  const [amazonConfigs, setAmazonConfigs] = useState([]);
  const [selectedAmazonConfigs, setSelectedAmazonConfigs] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const fetchAmazonConfigs = () => {
    setLoading(true);
    superagent
      .get(`${backendUrl}/amazon-configs`)
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
      .set('accept', 'json')
      .on('error', (response) => {
        const code = response.status;
        const errorMessage = response?.response?.body?.message || response?.body?.message || `Failed to fetch Amazon configs (Error ${code})`;
        toast.error(errorMessage);
        setLoading(false);
      })
      .then((response) => {
        const code = response.status;
        if (code > 400) {
          toast.error(`Failed to fetch Amazon configs (Error ${code})`);
        } else {
          setAmazonConfigs(response.body.data);
          setAllAmazonConfigs(response.body.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (modal) {
      fetchAmazonConfigs();
      setSelectedAmazonConfigs(amazonLinks || []);
    } else {

      setTempAmazonSelections([]);
    }
  }, [modal, amazonLinks, setTempAmazonSelections]);

  const handleSave = () => {
    setAmazonLinks(selectedAmazonConfigs);
    setTempAmazonSelections([]);
    togglemodal();
  };

  const toggleConfigSelection = (configId) => {
    setSelectedAmazonConfigs(prev => {
      const newSelections = prev.includes(configId)
        ? prev.filter(id => id !== configId)
        : [...prev, configId];


      setTempAmazonSelections(newSelections);

      return newSelections;
    });
  };

  return (
    <Dialog
      open={modal}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabindex="-1"
      size="lg"
      onOpenChange={togglemodal}
    >
      <DialogContent className="z-[1500] max-h-[80vh] overflow-y-auto pt-0 min-w-[60vw]">
        <CardBody className="p-0 px-0">
          <div className="flex items-center gap-3 mb-4 pt-6 px-6">
            <i className="bx bxl-amazon text-2xl text-orange-500"></i>
            <h4 className="card-title m-0">Select Amazon Configurations</h4>
          </div>

          {loading ? (
            <div className="flex justify-center items-center py-12">
              <div className="spinner-border text-primary m-1" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="px-6">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                {amazonConfigs.map((config) => (
                  <div
                    key={config._id}
                    className={`relative border-2 rounded-lg overflow-hidden transition-all duration-300 hover:shadow-lg ${selectedAmazonConfigs.includes(config._id)
                        ? 'border-orange-500 shadow-md'
                        : 'border-gray-200 hover:border-gray-300'
                      }`}
                  >
                    {selectedAmazonConfigs.includes(config._id) && (
                      <div className="absolute top-2 right-2 bg-orange-500 text-white rounded-full p-1 z-10">
                        <i className="bx bx-check text-sm"></i>
                      </div>
                    )}

                    <div className="p-4">
                      <div className="flex items-center gap-2 mb-3">
                        <i className="bx bxl-amazon text-orange-500 text-xl"></i>
                        <h5 className="font-semibold text-gray-800 m-0">{config.storeKey}</h5>
                      </div>

                      <div className="space-y-2 text-sm text-gray-600">
                        <div className="flex items-center gap-1">
                          <i className="bx bx-map text-gray-400"></i>
                          <span>Region: {config.region}</span>
                        </div>

                        <div className="flex items-center gap-1">
                          <i className="bx bx-store text-gray-400"></i>
                          <span>Marketplaces:</span>
                        </div>

                        <div className="pl-5 space-y-1 max-h-32 overflow-y-auto">
                          {config.marketplaces.map((marketplace) => (
                            <div key={marketplace.marketplaceId} className="text-xs">
                              <div className="font-medium">{marketplace.name} ({marketplace.countryCode})</div>
                              <div className="text-gray-500">{marketplace.domainName}</div>
                              <div className="text-gray-500">Currency: {marketplace.defaultCurrencyCode}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="bg-gray-50 px-4 py-3 border-t">
                      <button
                        onClick={() => toggleConfigSelection(config._id)}
                        className={`w-full py-2 px-4 rounded-md font-medium transition-colors ${selectedAmazonConfigs.includes(config._id)
                            ? 'bg-orange-500 text-white hover:bg-orange-600'
                            : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                          }`}
                      >
                        {selectedAmazonConfigs.includes(config._id) ? (
                          <span className="flex items-center justify-center gap-2">
                            <i className="bx bx-check"></i>
                            Selected
                          </span>
                        ) : (
                          <span className="flex items-center justify-center gap-2">
                            <i className="bx bx-plus"></i>
                            Select
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </CardBody>
        <DialogFooter>
          <Button onClick={togglemodal} variant="secondary">
            Cancel
          </Button>
          <Button onClick={handleSave} variant="success">
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LocationListPage;
